import React from "react";
import {TerminalReleaseShort} from "~/apps/packages/warehouse-closure/queries";
import {Card, CardActionArea, CardContent, Divider, Grid, Typography} from "@mui/material";
import moment from "moment";
import {makeStyles} from "@mui/styles";
import {PortTheme} from "~/ui/theme";
import {TerminalReleaseStatusBadge} from "~/apps/packages/warehouse-closure/components/TerminalReleaseStatusBadge";
import {NavigateNext} from "@mui/icons-material";
import {TypographyWithIcon} from "~/apps/core/ui/TypographyWithIcon";
import {formatDate} from "~/apps/core/utils";


export type TerminalReleaseItemProps = {
    terminalRelease: TerminalReleaseShort
}


const useStyles = makeStyles<PortTheme, TerminalReleaseItemProps>(theme => ({
    root: {
        width: "100%",
    }
}));


export const TerminalReleaseItem = (props: TerminalReleaseItemProps) => {
    const {terminalRelease} = props;
    const classes = useStyles(props);

    return (
        <Card className={classes.root}>
            <CardActionArea>
                <CardContent>
                    <Grid container direction="column" wrap="nowrap" rowSpacing="8px">
                        <Grid item container justifyContent="space-between">
                            <Grid item>
                                <TerminalReleaseStatusBadge>
                                    {terminalRelease.status}
                                </TerminalReleaseStatusBadge>
                            </Grid>
                            <Grid item>
                                <Typography variant="cardText">
                                    {formatDate(moment(terminalRelease.date, "YYYY-MM-DD"))}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Divider/>
                        </Grid>
                        <Grid item>
                            <Typography variant="cardTitle1" title={terminalRelease.cargoInfo} color="primary" display="block" noWrap>
                                {terminalRelease.cargoInfo}
                            </Typography>
                        </Grid>
                        <Grid item container justifyContent="flex-end">
                            <Grid item>
                                <TypographyWithIcon endIcon={<NavigateNext/>} color="textSecondary" variant="cardText" marginRight="-8px" marginBottom="-2px">
                                    Подробнее
                                </TypographyWithIcon>
                            </Grid>
                        </Grid>
                    </Grid>
                </CardContent>
            </CardActionArea>
        </Card>
    );
}